import React from 'react';
import {
    ResourceList,
    Tabs,
    Modal,
    ResourceItem,
    Thumbnail,
    TextStyle,
    Banner
} from '@shopify/polaris';
import { AppContext } from '../common/AppContext';

class ChooseOperationModal extends React.Component {

    state = {
        selectedTab: 0,
    };

    render() {

        const tabs = [
            {
                id: 'product-operatins',
                content: 'Product',
                accessibilityLabel: 'Product operations',
                panelID: 'product-operations-content-1',
            },
            {
                id: 'customer-operations',
                content: 'Customer',
                accessibilityLabel: 'Customer operations',
                panelID: 'customer-operations-content-1',
            },
            {
                id: 'order-operations',
                content: 'Order',
                accessibilityLabel: 'Order operations',
                panelID: 'order-operations-content-1',
            },
        ];

        let selectedType = "Product";

        if (this.state.selectedTab === 1) {
            selectedType = "Customer";
        }

        if (this.state.selectedTab === 2) {
            selectedType = "Order";
        }

        let allOperations = [
            {
                id: 100,
                type: 'Product',
                url: '/operations/new/remove',
                name: 'Bulk Remove Product Tags',
                details: 'Bulk remove single or multiple tags with ease.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-remove.png'
            },
            {
                id: 200,
                type: 'Product',
                url: '/operations/new/merge',
                name: 'Merge/Rename Product Tags',
                details: 'Combine multiple tags into a single tag or simply rename tags.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-merge.png'
            },
            {
                id: 300,
                type: 'Product',
                url: '/operations/new/custom',
                name: 'Custom Product Tag Operation',
                details: 'Use the full capabilities of Tag Genie featuring advanced filtering and complex operations. Combine multiple filters to remove, add, or replace tags.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-custom.png'
            },
            {
                id: 400,
                type: 'Customer',
                url: '/operations/new/remove',
                name: 'Bulk Remove Customer Tags',
                details: 'Bulk remove single or multiple tags with ease.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-remove.png'
            },
            {
                id: 500,
                type: 'Customer',
                url: '/operations/new/merge',
                name: 'Merge/Rename Customer Tags',
                details: 'Combine multiple tags into a single tag or simply rename tags.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-merge.png'
            },
            {
                id: 600,
                type: 'Customer',
                url: '/operations/customer/new/custom',
                name: 'Custom Customer Tag Operation',
                details: 'Use the full capabilities of Tag Genie featuring advanced filtering and complex operations. Combine multiple filters to remove, add, or replace tags.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-custom.png'
            },
            {
                id: 700,
                type: 'Order',
                url: '/operations/new/remove',
                name: 'Bulk Remove Order Tags',
                details: 'Bulk remove single or multiple tags with ease.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-remove.png'
            },
            {
                id: 800,
                type: 'Order',
                url: '/operations/new/merge',
                name: 'Merge/Rename Order Tags',
                details: 'Combine multiple tags into a single tag or easily rename tags.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-merge.png'
            },
            {
                id: 900,
                type: 'Order',
                url: '/operations/order/new/custom',
                name: 'Custom Order Tag Operation',
                details: 'Use the full capabilities of Tag Genie featuring advanced filtering and complex operations. Combine multiple filters to remove, add, or replace tags.',
                image: 'https://taggeniemain.blob.core.windows.net/images/app-scenarios-custom.png'
            },
        ];
        const selectedOperations = allOperations.filter(_ => _.type === selectedType);
        const appContext = this.context;

        if (selectedType === "Customer" && !appContext.hasCustomerPermissions) {
            return <Modal
                open={this.props.active}
                onClose={this.props.onClose}
                title="Choose tag operation"
                secondaryActions={[
                    {
                        content: 'Cancel',
                        onAction: this.props.onClose,
                    },
                ]}
            >
                <Tabs tabs={tabs} selected={this.state.selectedTab} onSelect={this.handleTabChange}>
                    <Banner
                        title="No Access to Customer Data"
                        action={{ content: 'Approve Permissions', onAction: this.onApprove }}
                        status="critical"
                    >
                        <p>
                            The app currently has no access to customer data. Please click the button to allow the app to access customer data in order to be able to work with customer tags.
                        </p>
                    </Banner>
                </Tabs>
            </Modal>
        }

        if (selectedType === "Order" && !appContext.hasOrderPermissions) {
            return <Modal
                open={this.props.active}
                onClose={this.props.onClose}
                title="Choose tag operation"
                secondaryActions={[
                    {
                        content: 'Cancel',
                        onAction: this.props.onClose,
                    },
                ]}
            >
                <Tabs tabs={tabs} selected={this.state.selectedTab} onSelect={this.handleTabChange}>
                    <Banner
                        title="No Access to order data"
                        action={{ content: 'Approve Permissions', onAction: this.onApproveOrder }}
                        status="critical"
                    >
                        <p>
                            The app currently has no access to order data. Please click the button to allow the app to access customer data in order to be able to work with customer tags.
                        </p>
                    </Banner>
                </Tabs>
            </Modal>
        }

        return (
            <Modal
                open={this.props.active}
                onClose={this.props.onClose}
                title="Choose tag operation"
                secondaryActions={[
                    {
                        content: 'Cancel',
                        onAction: this.props.onClose,
                    },
                ]}
            >
                <Tabs tabs={tabs} selected={this.state.selectedTab} onSelect={this.handleTabChange}>
                    <ResourceList
                        resourceName={{ singular: 'customer', plural: 'customers' }}
                        items={selectedOperations}
                        renderItem={(item) => {
                            const { id, url, name, details, image } = item;
                            const media = <Thumbnail size="large" source={image} />;
                            return (
                                <ResourceItem
                                    id={id}
                                    url={url}
                                    media={media}
                                    accessibilityLabel={`View details for ${name}`}
                                >
                                    <h3>
                                        <TextStyle variation="strong">{name}</TextStyle>
                                    </h3>
                                    <div>{details}</div>
                                </ResourceItem>
                            );
                        }}
                    />
                </Tabs>
            </Modal>
        );
    }

    onApprove = () => {
        this.context.requestPermissions();
    }

    onApproveOrder = () => {
        this.context.requestOrderPermissions();
    }

    handleTabChange = (newTab) => {
        this.setState({ selectedTab: newTab });
    }

    componentDidMount() {
    }
}

ChooseOperationModal.contextType = AppContext;

export default ChooseOperationModal;